import Component from './Download.vue';

export default {
  install(Vue) {
    Vue.component('BkfActionDownload', Component);
  },
};
